import { apiGetData } from '@/services/ApiService.js'

const state = () => ({
  items: [],
  bookmarks: [],
  count: 0,
  userInteract: false,
})

const actions = {
  /* Load Data */

  loadBookmarksCount({ commit, rootGetters }) {
    if (!rootGetters['session/getAuthStatus']) {
      commit('LOAD_BOOKMARKS_COUNT', 0)
      return
    }
    apiGetData('store/bookmarks/count')
      .then((response) => {
        commit('LOAD_BOOKMARKS_COUNT', Number(response) || 0)
      })
      .catch(() => {
        commit('LOAD_BOOKMARKS_COUNT', 0)
      })
  },
  setBookmarksData({ commit }, bookmarks) {
    commit('SET_BOOKMARKS_DATA', bookmarks)
  },
  loadBookmarksList({ commit, rootGetters }) {
    if (!rootGetters['session/getAuthStatus']) {
      commit('SET_BOOKMARKS_DATA', [])
      return Promise.resolve([])
    }
    return apiGetData('store/bookmarks/list')
      .then((response) => {
        const list = Array.isArray(response) ? response : []
        commit('SET_BOOKMARKS_DATA', list)
        return list
      })
      .catch(() => {
        commit('SET_BOOKMARKS_DATA', [])
        return []
      })
  },

  /* User Interactions */
  addToBookmarks({ commit, dispatch, rootGetters }, productId) {
    return dispatch('session/recoverSession', null, { root: true }).then(() => {
      if (!rootGetters['session/getAuthStatus']) {
        return false
      }

      return apiGetData('store/bookmarks/add/' + productId)
        .then((response) => {
          if (response.success) {
            commit('ADD_TO_BOOKMARKS', productId)
            dispatch('loadBookmarksCount', false)
          }
          return response.success
        })
        .catch((err) => {
          throw err.response.data
        })
    })
  },
  removeToBookmarks({ commit, dispatch }, productId) {
    return apiGetData('store/bookmarks/remove/' + productId)
      .then((response) => {
        if (response.success) {
          commit('REMOVE_TO_BOOKMARKS', productId)
          dispatch('loadBookmarksCount', false)
        }
        return response.success
      })
      .catch((err) => {
        throw err.response.data
      })
  },

  /* Paginator */
  changeCurrentPage({ commit, dispatch }, pageNumber) {
    dispatch('paginator/changeCurrentPage', pageNumber, { root: true })
    commit('REGISTER_INTERACT')
  },
}

const mutations = {
  LOAD_BOOKMARKS_COUNT(state, count) {
    state.count = count
  },
  SET_BOOKMARKS_DATA(state, bookmarks) {
    state.bookmarks = []
    state.bookmarks = bookmarks
  },
  REGISTER_INTERACT(state) {
    state.userInteract = !state.userInteract
  },

  ADD_TO_BOOKMARKS(state, productId) {
    if (!state.items.includes(productId)) {
      state.items.push(productId)
    }
  },
  REMOVE_TO_BOOKMARKS(state, productId) {
    state.items = state.items.filter((id) => id !== productId)
    state.bookmarks = state.bookmarks.filter(
      (b) => (b.product?.id ?? b.product_id) !== productId
    )
  },
}

const getters = {
  getBookmarksCount: (state) => {
    return state.count
  },
  getBookmarks: (state) => {
    return state.bookmarks
  },
  getUserInteract: (state) => {
    return state.userInteract
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
